﻿/*
 * Globalize Culture sv-SE
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("sv-SE", "default", {
    name: "sv-SE",
    englishName: "Swedish (Sweden)",
    nativeName: "svenska (Sverige)",
    language: "sv",
    numberFormat: {
      ",": " ",
      ".": ",",
      negativeInfinity: "-INF",
      positiveInfinity: "INF",
      percent: {
        ",": " ",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": ".",
        ".": ",",
        symbol: "kr"
      }
    },
    calendars: {
      standard: {
        "/": "-",
        firstDay: 1,
        days: {
          names: [
            "söndag",
            "måndag",
            "tisdag",
            "onsdag",
            "torsdag",
            "fredag",
            "lördag"
          ],
          namesAbbr: ["sö", "må", "ti", "on", "to", "fr", "lö"],
          namesShort: ["sö", "må", "ti", "on", "to", "fr", "lö"]
        },
        months: {
          names: [
            "januari",
            "februari",
            "mars",
            "april",
            "maj",
            "juni",
            "juli",
            "augusti",
            "september",
            "oktober",
            "november",
            "december",
            ""
          ],
          namesAbbr: [
            "jan",
            "feb",
            "mar",
            "apr",
            "maj",
            "jun",
            "jul",
            "aug",
            "sep",
            "okt",
            "nov",
            "dec",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "yyyy-MM-dd",
          D: "'den 'd MMMM yyyy",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "'den 'd MMMM yyyy HH:mm",
          F: "'den 'd MMMM yyyy HH:mm:ss",
          M: "'den 'd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Ytterligare hjälp",
      AddNewTab: "Lägg till ny flik",
      Alerts: "Aviseringar",
      ApplyFilter: "Använd filter",
      Approve: "Godkänn",
      Attachments: "Bilagor",
      Back: "Tillbaka",
      Basic: "Grundläggande",
      Between: "Mellan",
      Book: "Bok",
      Cancel: "Avbryt",
      Checked: "Kontrollerade",
      ClearFilter: "Rensa filter",
      Close: "Stäng",
      CloseCancelChanges: "Stäng och avbryt ändringar",
      CloseSaveChanges: "Stäng och spara ändringar",
      CloseTab: "Stäng flik",
      ColumnPersonalization: "Kolumnanpassning",
      Comments: "Kommentarer",
      Confirmation: "Bekräftelse",
      Contains: "Innehåller",
      CreateTab: "Skapa en ny flik",
      Cut: "Klipp ut",
      Delete: "Radera",
      DiscardUndo: "Kasta/ångra",
      DisplayDropDownList: "Visa listruta",
      Displaying: "Visar: ",
      DocWord: "Dokument",
      DoesNotContain: "Innehåller inte",
      DoesNotEndWith: "Slutar inte med",
      DoesNotEqual: "Är inte lika med",
      DoesNotStartWith: "Börjar inte med",
      Download: "Hämta",
      Duplicate: "Duplicera",
      Edit: "Redigera",
      EitherSelectedorNotSelected: "Antingen markerad eller inte",
      Email: "E-post",
      EndsWith: "Slutar med",
      EqualsStr: "Lika med",
      ExpandCollapse: "Visa/dölj",
      ExportFailed: "Exporten misslyckades",
      ExportToExcel: "Exportera till Excel",
      FileInUse: "Angiven fil används",
      FileInUseDetail:
        "Stäng filen i programmet där den används eller byt namn på den.",
      Filter: "Filter",
      FilterMenu: "Filtermeny",
      FilterOptions: "Filteralternativ",
      FilterWithinResults: "Filtrera resultatet",
      First: "Första",
      FirstView: "Första vyn",
      Folder: "Mapp",
      ForgotPassword: "Glömt lösenordet?",
      Forward: "Framåt",
      GetMoreRows: "Visa fler rader",
      GreaterThan: "Större än",
      GreaterThanOrEquals: "Större än eller lika med",
      GridSettings: "Rutnätsinställningar",
      GroupSelection: "Gruppval",
      Help: "Hjälp",
      HideColumn: "Dölj kolumn",
      IsEmpty: "Är tom",
      IsNotEmpty: "Är inte tom",
      Last: "Sista",
      LastView: "Sista vyn",
      LaunchActivate: "Starta/aktivera",
      LessThan: "Mindre än",
      LessThanOrEquals: "Mindre än eller lika med",
      Links: "Länkar",
      ListTabs: "Visa alla flikar",
      LoadingItem: "Läser in artikel ",
      Maintenance: "Underhåll",
      Menu: "Meny",
      New: "Nytt",
      Next: "Nästa",
      NextView: "Nästa vy",
      No: "Nej",
      NotChecked: "Inte kontrollerade",
      Notes: "Anteckningar",
      NotSelected: "Ej vald",
      Of: " av ",
      Ok: "OK",
      Open: "Öppna",
      Password: "Lösenord",
      Paste: "Klistra in",
      Phone: "Telefon",
      PleaseWait: "Vänta",
      Previous: "Föregående",
      PreviousView: "Föregående vy",
      Print: "Skriv ut",
      Queries: "Frågor",
      Redo: "Gör om",
      Refresh: "Uppdatera",
      Reject: "Avvisa",
      RememberMe: "Kom ihåg mig på den här datorn",
      Reports: "Rapporter",
      Reset: "Återställ",
      Review: "Granska",
      RunFilter: "Kör filter",
      RunJob: "Kör jobb",
      Save: "Spara",
      SaveBeforeClosing: "Spara innan stängning",
      SavedFilters: "Sparade filter",
      SaveSubmit: "Spara/skicka",
      ScreenDesign: "Skärmbildsdesign",
      Search: "Sök",
      SelectContents: "Välj innehåll",
      SelectDate: "Välj ett datum",
      SelectDeselect: "Markera/avmarkera allt",
      Selected: "Markerade: ",
      ServerName: "Servernamn",
      Settings: "Inställningar",
      ShowFilterRow: "Visa filterrad",
      SignIn: "Logga in",
      SortAscending: "Sortera stigande",
      SortDescending: "Sortera fallande",
      Spreadsheet: "Kalkylblad",
      StartsWith: "Börjar med",
      StatusIndicator: "Statusindikator",
      Tasks: "Uppgifter",
      Today: "Idag",
      Translate: "Översätt",
      UserID: "Användar-ID",
      Utilities: "Verktyg",
      Yes: "Ja",
      Page: "Sida",
      Rows: "Rader",
      ShowingAll: "Visa alla",
      SessionNavigation: "Sessionsnavigering",
      ListAllMenuItems: "Visa alla menyposter",
      NoRecordsFound: "Inga poster hittades",
      SearchTree: "Sök i träd",
      Clear: "Rensa",
      DrillDown: "Bryt ned",
      Required: "Fältet är obligatoriskt",
      Available: "Tillgängligt:",
      Add: "Lägg till",
      MoveDown: "Flytta ned",
      MoveUp: "Flytta upp",
      Remove: "Ta bort",
      LastYear: "Senaste året",
      NextMonth: "Nästa månad",
      NextWeek: "Nästa vecka",
      NextYear: "Nästa år",
      OneMonthAgo: "En månad sedan",
      OneWeekAgo: "En vecka sedan",
      SixMonthsAgo: "Sex månader sedan",
      Time: "Klockslag",
      CannotBeSelected: "Den här raden kan inte väljas.",
      ResetToDefault: "Återställ till standardlayouten",
      CloseOtherTabs: "Stäng andra flikar",
      EmailValidation: "Ange en giltig e-postadress",
      UrlValidation: "Ange en giltig URL",
      EndofResults: "Slut på resultaten",
      More: "Fler ...",
      RecordsPerPage: "Poster per sida",
      Maximize: "Maximera",
      Minimize: "Minimera",
      CloseAllTabs: "Stäng alla flikar",
      QuickDates: "Snabbdatum",
      Finish: "Slutför",
      SetTextColor: "Välj textfärg",
      AttachmentRules: "Kriterier för bilaga",
      AutoRefresh: "Automatisk uppdatering",
      BarChart: "Stapeldiagram",
      CopyMail: "Kopiera och skicka e-post",
      CopyUrl: "Kopiera URL",
      DistributeHorizontally: "Fördela horisontellt",
      ExpandAll: "Expandera alla",
      Generate: "Generera",
      GenerateScript: "Generera skript",
      NoAttachments: "Inga bilagor",
      PieChart: "Cirkeldiagram",
      QuickAccess: "Snabb åtkomst",
      RestoreUser: "Återställ användare",
      SaveConsolidate: "Spara med lokal konsolidering",
      "Screen Design": "Skärmdesign",
      SelectAll: "Markera alla",
      SpellCheck: "Stavningskontroll",
      SubmitForApproval: "Skicka för godkännande",
      TopDownSpread: "Top Down Spread",
      Timezone: "Tidszon",
      Loading: "Läser in ...",
      NewNode: "Ny nod"
    }
  });
})(this);
